import { Inject, Injectable } from '@angular/core';
import { RestService } from '../../../../core/services/rest.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { metropolitanBorder } from '../assets/metropolitanBorder';

//const METROPOLITAN_BORDER_URL = 'https://data-interne.ademe.fr/data-fair/api/v1/datasets/europe/lines?size=1&DPAY_C_ISO_eq=FR';

@Injectable({
    providedIn: 'root',
})
export class CracMapService {
    constructor(
        @Inject(RestService) private restService: RestService,
        //private http: HttpClient,
    ) {}

    public async get(organizationId: string, year: number): Promise<any> {
        const path = `/organization/${organizationId}/cracmap/${year}`;
        const data = await this.restService.get(path, {});
        return data;
    }

    public async getMetropolitanBorder(): Promise<any> {
        /*
            const path = METROPOLITAN_BORDER_URL;
            const data = await firstValueFrom(this.http.get<any>(path));
            if (data?.results?.length == 1) {
                return JSON.parse(data.results[0].geometry);
            }
            return null;
        */
        return metropolitanBorder;
    }
}
